(function () {
  function initCartQuantity() {
    document.querySelectorAll('[data-wc-cart-qty]').forEach(function (qty) {
      if (qty.dataset.wcCartQtyReady === 'true') return;

      var input = qty.querySelector('input');
      var minus = qty.querySelector('[data-wc-cart-qty-minus]');
      var plus = qty.querySelector('[data-wc-cart-qty-plus]');

      if (!input || !minus || !plus) return;

      qty.dataset.wcCartQtyReady = 'true';

      minus.addEventListener('click', function () {
        var current = parseInt(input.value || '0', 10);

        input.value = Math.max(0, current - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      plus.addEventListener('click', function () {
        var current = parseInt(input.value || '0', 10);

        input.value = current + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartQuantity);
  } else {
    initCartQuantity();
  }

  document.addEventListener('shopify:section:load', initCartQuantity);
})();